import Alpine from 'alpinejs';
import './jobs';
import './cookies';
import './toasts';
import './vacancy-alerts';

window.Alpine = Alpine;

document.addEventListener('DOMContentLoaded', async () => {
    const { imageData } = await import('../jobsites/application-form.js');
    Alpine.data('imageData', imageData);

    window.Alpine.start();
});